module.exports = __webpack_public_path__ + "img/syc.32d06f38.png";